module.exports = __webpack_public_path__ + "img/td.b38400dc.png";